import React, { useState } from "react";
import LoadingDots from "../../shared/LoadingDots";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ResetPasswordModal = ({ show, onClose, user, onReset }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const isValidPassword = (password) => {
    const specialChars = "~!@#$%^&*(){|?>";
    const regex = new RegExp(`^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[${specialChars.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}])[A-Za-z\\d${specialChars.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')}]{8,}$`);
    return regex.test(password);
  };

  const [formData, setFormData] = useState({
    password: "",
    password_confirmation: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  if (!show || !user) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setMessage({ type: "", text: "" }); // clear previous messages
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.password_confirmation) {
      setMessage({ type: "error", text: "Passwords do not match!" });
      return;
    }

    if (!isValidPassword(formData.password)) {
      setMessage({
        type: "error",
        text: "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.",
      });
      return;
    }

    try {
      setLoading(true);
      await onReset(user.id, formData);
      setMessage({ type: "success", text: "Password reset successfully!" });
      setFormData({ password: "", password_confirmation: "" });
    } catch (err) {
      setMessage({ type: "error", text: "Failed to reset password." });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({ password: "", password_confirmation: "" });
    setMessage({ type: "", text: "" });
    onClose();
  };

  return (
    <div className="popup">
      <div className="popup-content">
        <h2 className="user-form-heading text-lg font-semibold mb-4">
          Reset Password for {user.name}
        </h2>

        <form onSubmit={handleSubmit} className="user-form space-y-4">
          <div>
            <label className="user-form-heading block mb-1">New Password</label>
            <div className="flex mt-[5px]">
            <input
              type="text"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className={showPassword ? "unmasked" : "masked"}

            />
             <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="eyebtn"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
            </div>
          </div>

          <div>
            <label className="user-form-heading block mb-1">
              Confirm Password
            </label>
            <div className="flex mt-[5px]">
            <input
             type="text"
              name="password_confirmation"
              value={formData.password_confirmation}
              onChange={handleChange}
              required
              className={showConfirm ? "unmasked" : "masked"}
            />
             <button
              type="button"
              onClick={() => setShowConfirm(!showConfirm)}
              className="eyebtn"
            >
              {showConfirm ? <FaEyeSlash /> : <FaEye />}
            </button>
            </div>
          </div>

          {/* Inline message */}
          {message.text && (
            <div
              className={`text-sm ${
                message.type === "error" ? "error-msg " : "success-msg"
              }`}
            >
              {message.text}
            </div>
          )}

          <div className="flex justify-end gap-[10px] mt-4">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 rounded bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="primary"
            >
              {loading ? <LoadingDots color="#fff"  /> : "Reset Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
